// @flow

import type {Language, PortfolioNotificationEvent, ModalEventsOptions, EventsSortBy} from '@/types'

import React from 'react'
import {connect} from 'react-redux'
import {map} from 'ramda'
import {date} from '@/format'
import {portfoliosActions} from '@/store'

import Flag from '@/elements/flag'
import NoAvailableTableData from '@/elements/no-available-table-data'
import {getRuleName, getReportLinkDetailsForGA, checkRuleText} from '@/views/util'

type Props = {
  events: Array<PortfolioNotificationEvent>,
  l: Language,
  showCompanyReport: (string) => void,
  startDate: any,
  endDate: any,
  sortBy: (EventsSortBy) => void,
  sortOptions: ModalEventsOptions,
  loader: boolean,
  langCode: string,
  countryCode: string,
}

const renderRow = (props: Props) => (event: PortfolioNotificationEvent) =>
  <tr key={event.notificationEventId}>
    <td width="13%"><Flag code={event.companyCountryCode}/>&nbsp;&nbsp;{event.companyCountryCode} </td>
    <td width="18%">{event.eventDate && date(event.eventDate, props.langCode)}</td>
    <td width="37%">
      <a data-click_through={getReportLinkDetailsForGA(props.countryCode, event.companyId)}
        onClick={() => props.showCompanyReport(event.companyId)}
      >
        {event.companyName}
      </a>
    </td>
    <td width="32%">{getRuleName(checkRuleText(event), props.l)}</td>
  </tr>

const getSortIcon = (props) => (columnName) => {
  if (props.sortOptions.sortBy === columnName) {
    if (props.sortOptions.sortDir === 'asc') {
      return 'sort-by drop-up'
    } else {
      return 'sort-by drop-down'
    }
  }
  return 'sort-by'
}

const renderRows = (props) => map(renderRow(props))

const RawNotificationTable = (props: Props) =>
  <table className="table table-condensed notifications-table">
    <thead>
      <tr className={props.events.length === 0 ? 'disabled-header' : ''}>
        <th width="13%" onClick={() => props.events.length > 0 ? props.sortBy('countryCode') : null}>{props.l('Country')}<span className={getSortIcon(props)('countryCode')}></span></th>
        <th width="18%" onClick={() => props.events.length > 0 ? props.sortBy('eventDate') : null}>{props.l('Date')}<span className={getSortIcon(props)('eventDate')}></span></th>
        <th width="37%" onClick={() => props.events.length > 0 ? props.sortBy('companyName') : null}>{props.l('Name')}<span className={getSortIcon(props)('companyName')}></span></th>
        <th width="32%" onClick={() => null}>{props.l('Event')}</th>
      </tr>
    </thead>
    <tbody className={props.events.length ? 'scroll' : ''}>
      {
        props.events.length
          ? renderRows(props)(props.events)
          : <NoAvailableTableData numOfCols={4} text={props.loader ? '' : props.l('No events found')}/>
      }
    </tbody>
  </table>

export default connect(
  null,
  portfoliosActions,
)(RawNotificationTable)



// WEBPACK FOOTER //
// ./src/views/notification-counts/notification-table.js